<h2 mat-dialog-title>{{ data.title }}</h2>
<div class="action-description">
    {{ data.content }}
</div>
<mat-dialog-content class="action-dialog-content">
    @if (data.endpointId) {
        <div class="detail-row">
            <strong>Endpoint ID:</strong>
            <span>{{ data.endpointId }}</span>
        </div>
    }
    @if (data.model) {
        <div class="detail-row">
            <strong>Model:</strong>
            <span>{{ data.model }}</span>
        </div>
    }
    @if (data.product) {
        <div class="detail-row">
            <strong>Product:</strong>
            <span>{{ data.product }}</span>
        </div>
    }
    @if (data.scope) {
        <div class="detail-row">
            <strong>Scope:</strong>
            <span>{{ data.scope }}</span>
        </div>
    }
    @if (data.execution) {
        <div class="detail-row">
            <strong>Execution:</strong>
            <span>{{ data.execution }}</span>
        </div>
    }
    @if (data.showEndpointBox) {
        <p>
            {{ data.endpointPrompt || 'Enter the Endpoint ID:' }}
        </p>
        <mat-form-field
            appearance="outline"
            class="endpoint-id-field">
            <mat-label>Endpoint ID</mat-label>
            <input
                matInput
                [formControl]="endpointIdControl"
                autocomplete="off">
            @if (endpointIdControl.hasError('endpointMismatch')) {
                <mat-error>
                    Endpoint ID does not match.
                </mat-error>
            }
        </mat-form-field>
    }
    @if (data.showAcknowledgeCheck) {
        <mat-checkbox [formControl]="acknowledgeControl">
            {{ data.acknowledgeCheckPrompt || 'I acknowledge this action.' }}
        </mat-checkbox>
    }
    @if (data.showDate) {
        <mat-form-field
            appearance="outline"
            class="endpoint-id-field">
            <mat-label>
                {{ data.datePrompt || 'Select Date' }}
            </mat-label>
            <input
                matInput
                [matDatepicker]="picker"
                [formControl]="dateControl">
            <mat-datepicker-toggle
                matIconSuffix
                [for]="picker">
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    }
    @if (data.showRanges) {
        <p>
            {{ data.rangePrompt || 'Select ranges:' }}
        </p>
        <mat-form-field
            appearance="outline"
            class="range-field">

            <mat-label>Range</mat-label>

            <input
                matInput
                type="number"
                min="0"
                [formControl]="rangeControl">

        </mat-form-field>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-raised-button
        type="button"
        (click)="cancel()">
        {{ data.rejectBtnName || 'Cancel' }}
    </button>
    <button
        mat-raised-button
        color="warn"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()">
        {{ data.acceptBtnName || 'Confirm' }}
    </button>
</mat-dialog-actions>